// ABOUTME: Stimulus controller que carrega cursos ao selecionar centro.
// ABOUTME: Popula select de cursos com dados da API, suportando allWhenEmpty.

import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js"
import { createElement } from "@uenf/layout";
import { routes } from "../routes";

export default class extends Controller {
  static targets = ["centrosSelect", "cursosSelect"];
  static values = { allWhenEmpty: Boolean };

  async change() {
    const queryParams = { curso_centro_id: this.centrosSelectTarget.value };
    if (this.allWhenEmptyValue) { queryParams.all_when_empty = true; }
    const response = await get(
      routes.queryCursosPath(queryParams),
      { responseKind: "json" }
    );

    this.cursosSelectTarget.innerHTML = "";

    if (response.ok) {
      this.cursosSelectTarget.appendChild(createElement("option", { value: "" }));
      const cursosData = await response.json;
      cursosData.forEach(curso => {
        this.cursosSelectTarget.appendChild(
          createElement("option", { value: curso.id }, curso.nome)
        );
      });
    }
  }
};
